/**
 * @generated SignedSource<<1eb79fb13f3a43359c9a54b1409d8a3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CurrencySelectAllCurrencies2Query$variables = {};
export type CurrencySelectAllCurrencies2Query$data = {
  readonly allCurrencies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isoCurrencyCode: string;
      } | null;
    } | null>;
  } | null;
};
export type CurrencySelectAllCurrencies2Query = {
  response: CurrencySelectAllCurrencies2Query$data;
  variables: CurrencySelectAllCurrencies2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CurrencyNodeConnection",
    "kind": "LinkedField",
    "name": "allCurrencies",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrencyNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isoCurrencyCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CurrencySelectAllCurrencies2Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CurrencySelectAllCurrencies2Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "86cefe1713d3958f265767e729a2f3a0",
    "id": null,
    "metadata": {},
    "name": "CurrencySelectAllCurrencies2Query",
    "operationKind": "query",
    "text": "query CurrencySelectAllCurrencies2Query {\n  allCurrencies {\n    edges {\n      node {\n        id\n        isoCurrencyCode\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf0e56f489471feac733fa278a6b6b6d";

export default node;
